import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const JiraShape = {
  api_email: Yup.string().label("API Email Address").required(),
  api_token: Yup.string().label("API Token or Password").required(),
  jira_subdomain: Yup.string().label("Jira Subdomain").url().min(20).max(255).required(),
  project_key: Yup.string().label("Project Key").required(),
  labels: Yup.string().label("Labels").max(1000).optional(),
  custom_field_id_account_name: Yup.string().label("Account Name Custom Field ID").optional().nullable(),
  custom_field_id_check_name: Yup.string().label("Check Name Custom Field ID").optional().nullable(),
  custom_field_id_check_url: Yup.string().label("Check URL Custom Field ID").optional().nullable(),
  custom_fields_json: Yup.string().label("Additional Custom Fields").optional(),
  alert_resolved_label: Yup.string().label("Alert Resolved Label").max(1000).optional(),
};

export interface JiraInput {
  api_email: string;
  api_token: string;
  jira_subdomain: string;
  project_key: string;
  labels?: string;
  custom_field_id_account_name?: string | null;
  custom_field_id_check_name?: string | null;
  custom_field_id_check_url?: string | null;
  custom_fields_json?: string;
  alert_resolved_label?: string;
}

export const JiraDefaults = {
  jira_subdomain: "https://",
};

yupResolver<JiraInput>(Yup.object().shape(JiraShape));
